import { useTranslation } from 'react-i18next';
import { BasePage } from './BasePage';
import { ExpectedError } from '../../utils/errors';

export function NotFoundPage(): JSX.Element {
    const { t } = useTranslation();
    const title = t('Page not found');
    return <BasePage title={title}>{title}</BasePage>;
}

export class NotFoundError extends ExpectedError {
    FallbackElement: typeof NotFoundPage = NotFoundPage;
}
